import React from 'react'
import { Col, Collapse, Row, Table, Tabs, Radio, Carousel } from "antd";
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

// Components
import Container from "../../../../containers/Container";
import ThongTinChiTiet from './thongTinChiTiet'
import BaoCaoDinhKy from '../../../../components/MoiTruong/BaoCaoDinhKy'
import ViTriQuanTrac from '../../../../components/MoiTruong/ViTriQuanTrac'
import BieuDo_BCDK from '../../../../components/License/BieuDo/BieuDoMT'
import Api_quantrac from "../../../../api/api.quantrac"
const { Panel } = Collapse;
const { TabPane } = Tabs;
class DeAnDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      changeBieudo: 1,
    }
  }

  componentDidMount() {

  }

  render() {
    const { idGiayPhep, selectedRow, editable, isMap,phanloai,showmap,handleMap} = this.props;
    const { changeBieudo } = this.state
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };
    return (
      <Container>
        <Tabs type="card" style={{ width: "100%" }}>
          {!isMap &&
          <TabPane tab="Thông tin chi tiết" key="1">
            <ThongTinChiTiet
              idHoSo={idGiayPhep}
            />
          </TabPane>}
          <TabPane tab="Báo cáo định kỳ" key="2">
            <Row type='flex' justify='end'>
              <Radio.Group name="radiogroup" defaultValue={1} >
                <Radio style={radioStyle} value={1} onChange={(e) => e.target.value === 1 && this.setState({ changeBieudo: 1 })}>Danh sách</Radio>
                <Radio style={radioStyle} value={2} onChange={(e) => e.target.value === 2 && this.setState({ changeBieudo: 2 })}>Biểu đồ</Radio>
              </Radio.Group>
            </Row>

            <div className="mt-20"></div>
            <div style={{ minHeight: 500 }}>
              {changeBieudo === 1 &&
                <BaoCaoDinhKy
                  idGiayPhep={idGiayPhep}
                  data_giayphep={selectedRow}
                  editable={editable}
                  apiGetBCDK_by_QD={new Api_quantrac().GetBCDK_By_QD}
                  apiGetBCDK_by_ID={new Api_quantrac().GetDTM_BaoCaoDinhKy}
                  apiDeleteBCDK={ new Api_quantrac().DeleteDTM_BaoCaoDinhKy}
                  phanloai="DTM"
                />}
              {changeBieudo === 2 &&
                <BieuDo_BCDK
                  idGiayPhep={idGiayPhep}
                  apiGetBCDK_by_QD={new Api_quantrac().GetBCDK_By_QD}
                />
              }
            </div>
          </TabPane>
          <TabPane tab="Vị trí quan trắc" key="3">
            <ViTriQuanTrac
              idGiayPhep={idGiayPhep}
              data_giayphep={selectedRow}
              editable={editable}
              apiGetTram_by_QD={new Api_quantrac().GetDTM_TramQuanTracs_By_DTM}
              apiGetBVMT_Tram={new Api_quantrac().GetDTM_TramQuanTrac}
              apiDelete_Tram={new Api_quantrac().DeleteDTM_TramQuanTrac}
              apiGetTPMT_Exist={new Api_quantrac().GetTPMT_Exist_DTM}
              apiGetMauQT_by_Tram={new Api_quantrac().GetMauQTs_By_TramQT_DTM}
              apiSoLan_VuotNguong={new Api_quantrac().GetBieuDo_SoLanVuotNguong_DTM}
              apiThongSo_Exist={new Api_quantrac().GetThongSos_Exist_DTM}
              apiGiaTriTimeLine={new Api_quantrac().GetBieuDo_ThongSos_GiaTris_Timeline_DTM}
              apiGetBCDK_KQQT_By_ThongSo={new Api_quantrac().GetBCDK_KQQT_By_ThongSo}
              apiGetBCDK_KQQT={new Api_quantrac().GetBCDK_KQQT}
              apiGetDanhGia_Excel={new Api_quantrac().GetBCDK_KQQT_Excel_DTM}
              phanloai="DTM"
              showmap={showmap}
              handleMap={handleMap}
            />
          </TabPane>
        </Tabs>
      </Container>
    )
  }
}

DeAnDetail.propTypes = {
  idGiayPhep: PropTypes.string
};


const mapStateToProps = (state) => ({
  user: state.oidc.user
});

export default connect(mapStateToProps)(DeAnDetail)